import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { tap } from 'rxjs/operators';
import { ToastService } from '../../../../../main/services';
import { Tender } from '../../../../models';
import { TenderContractsService } from '../../../../services';

@Component({
    selector: 'jft-contracts-table-import-modal',
    templateUrl: './contracts-import-table-modal.component.html',
    styleUrls: ['./contracts-import-table-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractsImportTableModalComponent implements OnInit {

    public loading: boolean = false;
    public dataTable: any[] = [];

    constructor(
        public tender: Tender,
        private contractService: TenderContractsService,
        private toast: ToastService,
        private activeModal: NgbActiveModal,
    ) {
    }

    public saveTable() {
        this.loading = true;
        this.contractService.uploadTableContracts(this.tender, this.dataTable)
            .pipe(tap(() => this.loading = false))
            .subscribe(data => {
                // `messages` is the importer's stats dict (Plan 8 review M14), not a list.
                const stats = data?.messages || {};
                const imported = (stats.locations_imported || []).length;
                const skipped: any[] = stats.locations_skipped || [];
                if (imported) {
                    this.toast.success(`${imported.toLocaleString('en-US')} imported.`);
                } else if (!skipped.length) {
                    this.toast.error('No locations imported.');
                }
                skipped.forEach(row => this.toast.error(`Row ${row.row} not imported: ${row.reason}`));
                this.activeModal.close();
            }, (err) => {
                this.close();
                this.toast.error(err);
            });
    }

    public downloadTemplate() {
        this.contractService.downloadLocationsXlsTemplate(this.tender);
    }

    public ngOnInit() {
        this.dataTable = this.getDefaultDataTable()
    }

    public close() {
        this.activeModal.dismiss();
    }

    /**
     * todo move to model
     */
    public getDefaultDataTable() {
        return []
    }
}
